<script setup lang="ts">
import useLgoSyncState from "@/core/composables/sante-secure/useLgoSyncState";

const {isSyncStale} = useLgoSyncState({refreshOnMount: true});

/**
 * A development post has no LGO syncing to it: the notice would show on every
 * detection, and say nothing about the code being worked on.
 */
const isDev = import.meta.env.DEV;

/**
 * Open apodis secure guide modal.
 */
const showApodisSecureGuide = () => {
    window.ipcRenderer.click();
    window.ipcRenderer.send('navigate', '/home', false);
};
</script>

<template>
  <div
    v-if="isSyncStale && !isDev"
    class="rounded-lg border border-orange-200 text-sm bg-orange-50 p-3"
  >
    <div class="flex items-start gap-3">
      <div class="flex flex-1 flex-col">
        <div class="flex flex-row items-center gap-2">
          <p class="text-lg">⚠️</p>
          <p class="text font-semibold">Synchronisation interrompue</p>
        </div>
        <p class="text leading-relaxed">Vos données ne sont plus à jour.</p>
        <div class="flex items-end justify-end">
          <button
            class="mt-1 self-start text font-medium text-primary underline-offset-2 hover:underline"
            @click="showApodisSecureGuide"
          >
            En savoir plus
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
